import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-add-company-modal',
  templateUrl: './add-company-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-company-modal.component.scss']
})
export class AddCompanyModalComponent {
  public companyForm: FormGroup
  public isLoading: boolean = false
  public isSuccess: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddCompanyModalComponent>,
    private fb: FormBuilder,
    private wellHeaderInfoService : WellHeaderInfoService) {
  }

  ngOnInit(){
    this.companyForm = this.initializeForm()
  }

  initializeForm(){
    return this.fb.group({
      companyLongName : ['', [Validators.required, noWhitespaceValidator()]],
      companyShortName : ['', [Validators.required, noWhitespaceValidator()]],
      country: ['', [Validators.required, noWhitespaceValidator()]],
      location: ['', [Validators.required, noWhitespaceValidator()]],
      remarks : '',
    })
  }

  createCompany(){
    this.isLoading = true
    this.wellHeaderInfoService.createCompany(this.companyForm.value).subscribe({
      next: (res) => {
        if(res.isSuccess){
          this.isSuccess = true
          this.closeDialog()
        }

        this.isLoading = false
      },
      error: (err) => this.isLoading = false
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get companyLongName() {
    return this.companyForm.get('companyLongName');
  }

  get companyShortName() {
    return this.companyForm.get('companyShortName');
  }

  get country() {
    return this.companyForm.get('country');
  }

  get location() {
    return this.companyForm.get('location');
  }
}
